export default "__VITE_ASSET__BM7jo8$p__"